<template>
    <div class="con-btn">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>代理下单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :model="contractGoods">
            <div class="block-container">
                <div class="content-caption dashed bg-white">
                    <span>选择合同</span>
                </div>

                <div class="form-single mt20 mb20">
                    <div class="title">合同编号</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 225px">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="contractNo"></el-input>
                        </div>
                    </div>
                </div>

                <div v-if="contractNo != null && trackPhaseList != null && trackPhaseList.length > 0" class="form-single mt20 mb20">
                    <div class="title required">选择合同阶段</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 313px">
                            <el-select placeholder="请选择" class="fl" v-model="trackPhaseId">
                                <el-option v-for="trackPhase in trackPhaseList" :key="trackPhase.id" :label="trackPhase.name" :value="trackPhase.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title required">配货方式</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 225px">
                            <el-radio-group v-model="goodsOrder.manualAllocFlag">
                                <el-radio :label="true">手工配货</el-radio>
                                <el-radio :label="false">自动配货</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">税率(%)</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 225px">
                            <span>{{goodsOrder.taxRate}}</span>
                        </div>
                    </div>
                </div>
                <div class="content-caption dashed bg-white">
                    <span>选择零售商</span>
                </div>

                <div>
                    <div class="form-single mt20 mb20">
                        <div class="title">选择零售商</div>
                        <div class="content">
                            <div class="pos-rel" style="width: 225px">
                                <el-input class="width-1-5x bottom-line" :disabled="true" v-model="contractBizRel.fstPartyName"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form-single mt20 mb20">
                        <div class="title">业务开始日期</div>
                        <div class="content">
                            <div class="pos-rel" style="width: 225px">
                                <el-input class="width-1-5x bottom-line" :disabled="true" v-model="contractBizRel.dateStart"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form-single mt20 mb20">
                        <div class="title">业务截止日期</div>
                        <div class="content">
                            <div class="pos-rel" style="width: 225px">
                                <el-input class="width-1-5x bottom-line" :disabled="true" v-model="contractBizRel.dateEnd"></el-input>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="content-caption dashed bg-white">
                    <span>配货机构信息</span>
                </div>

                <div class="simple-row">
                    <div class="left">
                        <a class="swb-btn swb-btn-small" @click="showShopDlg()">选择机构</a>
                    </div>
                </div>
                <table class="custom-tbl">
                    <thead class="head">
                    <tr class="row">
                        <th class="align-left">机构名称</th>
                        <th class="align-left">地址</th>
                        <th>邮箱</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-if="retailerCom != null" class="row">
                        <td class="align-left">{{retailerCom.name}}</td>
                        <td class="align-left">{{retailerCom.regionName + retailerCom.street}}</td>
                        <td>{{retailerCom.contactEmail}}</td>
                        <td>
                            <span class="swb-btn-link" @click="removeRetailerCom()">移除</span>
                        </td>
                    </tr>
                    <tr class="row" v-else>
                        <td colspan="4">暂无机构信息</td>
                    </tr>
                    </tbody>
                </table>
                <div class="btn-row bg-white" v-if="retailerCom != null">
                    <div class="left-btn fl">
                        <a class="swb-btn swb-btn-small mr10" @click="showShopAddrDlg()">选择地址</a>
                    </div>
                </div>
                <table class="custom-tbl" v-if="retailerCom != null">
                    <thead class="head">
                    <tr class="row">
                        <th>省市县</th>
                        <th>详细地址</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-if="retailerCom != null" class="row">
                        <td>
                            <div class="inline-block mr10" style="width: 500px">{{retailerCom.shopAddrRegionName}}</div>
                        </td>
                        <td>
                            <el-input class="inline-block" placeholder="详细地址" style="width: 500px" v-model="retailerCom.shopAddrStreet"></el-input>
                        </td>
                    </tr>
                    <tr class="row" v-else>
                        <td colspan="1">暂无地址信息</td>
                    </tr>
                    </tbody>
                </table>
                <div class="content-caption dashed bg-white">
                    <span>联系人信息</span>
                </div>
                <div>
                    <div class="form-single mt20 mb20">
                        <div class="title required">联系人</div>
                        <div class="content">
                            <div class="pos-rel" style="width: 225px">
                                <el-input type="input" v-model="contactName"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form-single mt20 mb20">
                        <div class="title required">联系电话</div>
                        <div class="content">
                            <div class="pos-rel" style="width: 225px">
                                <el-input type="input" v-model="contactTel"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-caption dashed bg-white">
                    <span>商品信息</span>
                </div>

                <div>
                    <el-table ref="multipleTable" :data="contractGoodsList" border tooltip-effect="dark" style="width: 100%">
                        <el-table-column align="left" prop="title" label="名称"></el-table-column>
                        <el-table-column align="left" prop="catName" label="分类"></el-table-column>
                        <el-table-column align="left" prop="brandName" label="品牌"></el-table-column>
                        <el-table-column align="left" prop="model" label="型号"></el-table-column>
                        <el-table-column align="left" prop="fixedSpec" label="规格"></el-table-column>
                        <!--<el-table-column align="center" width="120px" label="提供商品标识码">-->
                        <!--<template slot-scope="scope">-->
                        <!--<input type="checkbox" v-model="scope.row.vendorUknoFlag"/>-->
                        <!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column align="center" label="需安装">-->
                        <!--<template slot-scope="scope">-->
                        <!--<input type="checkbox" v-model="scope.row.setupFlag"/>-->
                        <!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column align="center" label="需组装">-->
                        <!--<template slot-scope="scope">-->
                        <!--<input type="checkbox" v-model="scope.row.asmblFlag"/>-->
                        <!--</template>-->
                        <!--</el-table-column>-->
                        <el-table-column align="center" prop="asmblAccFlag" label="组装件">
                            <template slot-scope="scope">
                                <span>{{scope.row.asmblAccFlag ? '是' : '否'}}</span>
                            </template>
                        </el-table-column>
                        <!--<el-table-column align="right" label="到货天数">-->
                        <!--<template slot-scope="scope">-->
                        <!--<el-input type="text" v-model="scope.row.arriveDays" @blur="validateBaseQuantity(scope.row)"></el-input>-->
                        <!--</template>-->
                        <!--</el-table-column>-->
                        <el-table-column align="right" label="含税价(元)">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.price != null">{{scope.row.price}}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" label="税率(%)">
                            <template slot-scope="scope">
                                <span v-if="checkActionPerm('view_item_price')">{{scope.row.taxRate}}</span>
                                <span v-else>没有权限</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="ntxPrice" label="未税价(元)">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.ntxPrice != null">{{scope.row.ntxPrice}}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="wrntPeriod" label="质保期(月)"></el-table-column>
                        <el-table-column align="right" prop="quantity" label="合同总数量" v-if="contractNo != null && contractBizRel != null && contractBizRel.kindId != null && contractBizRel.kindId == 0"></el-table-column>
                        <el-table-column align="right" label="剩余数量" v-if="contractNo != null && contractBizRel != null && contractBizRel.kindId != null && contractBizRel.kindId == 0">
                            <template slot-scope="scope">
                                <span>{{scope.row.quantity - scope.row.surplusQuantity}}{{scope.row.unit}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="unit" label="单位" width="80px"></el-table-column>
                        <el-table-column align="right" label="下单数量">
                            <template slot-scope="scope">
                                <el-input :disabled="(scope.row.quantity - scope.row.surplusQuantity <= 0) && contractNo != null && contractBizRel != null && contractBizRel.kindId != null && contractBizRel.kindId == 0" type="text" @change="quantityChanges(scope);" v-model="scope.row.goodsQuantity"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="说明">
                            <template slot-scope="scope">
                                <el-input type="text" v-model="scope.row.desc"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <a class="swb-btn-link" @click="removeContractGoods(scope.row.skuId)">移除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="content-caption dashed bg-white">
                    <span>到货日期</span>
                </div>

                <div class="form-single mt20 mb20">
                    <div class="title required">要求到货日期</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 225px">
                            <el-date-picker v-model="goodsOrder.desireArriveDate" type="date" placeholder="选择日期" :picker-options="pickerOptions0"></el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20" v-if="contractNo != null && goodsOrder.desireArriveDays != null">
                    <div class="title">要求到货天数</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 225px">
                            <span>{{goodsOrder.desireArriveDays}} &nbsp 天 </span>
                        </div>
                    </div>
                </div>

                <div class="content-caption dashed bg-white">
                    <span>要求</span>
                </div>
                <div>
                    <!--<div class="form-single mt20 mb20">
                        <div class="title required">是否开发票</div>
                        <el-radio-group v-model="goodsOrderAndTradeDto.invoiceClaimed">
                            <el-radio :label="false">否</el-radio>
                            <el-radio :label="true">是</el-radio>
                        </el-radio-group>
                    </div>
                    <div v-if="goodsOrderAndTradeDto.invoiceClaimed == true">
                        <div class="form-single mt20 mb20">
                            <div class="title required">收货时段</div>
                            <div class="content">
                                <ul class="enum-list">
                                    <li v-for="(recvFrame,index) in recvFrameList" class="enum-item" v-bind:class="{checked: goodsOrderAndTradeDto.recvFrame ==recvFrame.value}" v-model="recvFrame.value" @click="changRecvFrame(recvFrame,index)">
                                        <span>{{recvFrame.text}}</span>
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="form-single mt20 mb20">
                            <div class="title required">发票主体类型</div>
                            <ul class="enum-list">
                                <li v-for="(invoiceSubjectType,index) in invoiceSubjectTypeList" class="enum-item" v-bind:class="{checked: goodsOrderAndTradeDto.invoiceSubjectType ==invoiceSubjectType.value}" v-model="invoiceSubjectType.value" @click="changInvoiceSubjectType(invoiceSubjectType,index)">
                                    <span>{{invoiceSubjectType.text}}</span>
                                    <i></i>
                                </li>
                            </ul>
                        </div>
                        <div class="form-single mt20 mb20">
                            <div class="title required">发票类型</div>
                            <div class="content">
                                <ul class="enum-list">
                                    <li v-for="(invoiceType,index) in invoiceTypeList" class="enum-item" v-bind:class="{checked: goodsOrderAndTradeDto.invoiceType ==invoiceType.value}" v-model=" invoiceType.value" @click="changInvoiceTypeType(invoiceType,index)">
                                        <span>{{invoiceType.text}}</span>
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="form-single mt20 mb20">
                            <div class="title required">发票内容标签</div>
                            <div class="content">
                                <ul class="enum-list">
                                    <li v-for="(invoiceContentTag,index) in invoiceContentTagList" class="enum-item" v-bind:class="{checked: goodsOrderAndTradeDto.invoiceContentTag ==invoiceContentTag.name}" v-model=" invoiceContentTag.value" @click="changInvoiceContentTag(invoiceContentTag,index)">
                                        <span>{{invoiceContentTag.name}}</span>
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="form-single mt20 mb20">
                            <div class="title required">发票抬头</div>
                            <div class="content">
                                <div class="pos-rel" style="width: 225px">
                                    <el-input class="width-1-5x bottom-line" v-model="goodsOrderAndTradeDto.invoiceTitle"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="form-single mt20 mb20">
                            <div class="title required">纳税人识别号</div>
                            <div class="content">
                                <div class="pos-rel" style="width: 225px">
                                    <el-input class="width-1-5x bottom-line" v-model="goodsOrderAndTradeDto.taxPayerNo"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content-caption dashed bg-white">
                        <span>支付信息</span>
                    </div>
                    <div class="form-single mt20 mb20">
                        <div class="title required">付款时机</div>
                        <div class="content">
                            <el-form-item prop="peerMerchantName">
                                <ul class="enum-list">
                                    <li v-for="(payTiming,index) in payTimingList" class="enum-item" v-bind:class="{checked: goodsOrderAndTradeDto.payTiming ==payTiming.value }" v-model="goodsOrderAndTradeDto.payTiming" @click="changPayTiming(payTiming,index)">
                                        <span>{{payTiming.text}}</span>
                                        <i></i>
                                    </li>
                                </ul>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-single">
                        <div class="title required">支付方式</div>
                        <div class="content">
                            <ul class="enum-list">
                                <li v-for="(payWay,index) in payWayList" class="enum-item" v-bind:class="{checked: goodsOrderAndTradeDto.payWay ==payWay.value }" v-model="goodsOrderAndTradeDto.payWay" @click="changPayWay(payWay,index)">
                                    <span>{{payWay.text}}</span>
                                    <i></i>
                                </li>
                            </ul>
                        </div>
                    </div>-->
                    <div class="form-single mt20 mb20">
                        <div class="title required">交易总金额</div>
                        <div class="content">
                            <div class="pos-rel" style="width: 225px">
                                <span>{{goodsOrderAndTradeDto.totalAmount}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-single mt20 mb20">
                        <div class="title">附言</div>
                        <div class="content">
                            <div class="pos-rel" style="width: 600px">
                                <el-input type="textarea" class="width-1-5x bottom-line" :rows="3" placeholder="附言最大长度120个字" :maxlength="120" :minlength="10" v-model="servcOrder.postscript"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-toolbar">
                <a class="swb-btn swb-btn-small" @click="saveGoodsOrder()">提交</a>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    import { openRetailerShopListForSelectDlg } from '../retailer/selectDlg';

    import contractApi from '../../api/contract'
    import merchtFinacApi from '../../api/merchtFinac'
    import goodsOrderApi from '../../api/goodsOrder'
    import retailerApi from '../../api/retailer'

    import SwbGoodsOrderList from './GoodsOrderList';
    Routes.add(SwbGoodsOrderList);

    import IntegPurchContractList from '../contract/IntegPurchContractList';
    Vue.regist(IntegPurchContractList);

    import SwbRetailerAddrSelect from '../retailer/RetailerAddrSelect'
    Vue.regist(SwbRetailerAddrSelect);

    export default {
        name: 'swb-proxy-goods-order',
        path: '/servc/proxy/order',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '商品代理下单',
        data: function () {
            return {
                //
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },

                servcOrder: {},
                trackPhaseId: null,
                trackPhaseList: [],
                contractNo: null,
                merchantName: null,
                merchantBizRel: {},
                contractBizRel: {},
                contractGoodsList: [],
                contractGoods: {},
                mkuList: [],
                mku: {},
                orderQuantity: null,
                skuIds: [],

                buyerId: null,
                goodsOrderAndTradeDto: {
                    invoiceClaimed: false,
                    payWay: null,
                    invoiceType: null,
                    invoiceTitle: null,
                    invoiceContentTag: null,
                    taxPayerNo: null,
                    recvFrame: 0,
                    invoiceSubjectType: 1,
                    totalAmount: 0,
                },
                goodsOrder: {
                    desireArriveDate: null,
                    manualAllocFlag: false,
                    taxRate: null
                },
                payWayList: [],//支付方式
                payTimingList: [],//支付时机
                recvFrameList: [],//收货时段
                invoiceTypeList: [],//发票类型
                invoiceSubjectTypeList: [],//发票主题
                invoiceContentTagList: [],//发票标签
                retailerMerchantType: {},
                //
                retailerCom: null,
                retailerComId: null,
                contactName: null,
                contactTel: null,
                bizAreaIds: [], // 区域ids
                bizFormIds: [] // 经营业态ids
            }
        },
        created: function () {
            //保持pageSize的一致性
            //
            let contractId = this.$route.query.contractId || null;
            let bizAreaIdStr = this.$route.query.bizAreaIdStr || null;
            if(!Utils.isNoB(bizAreaIdStr)) {
                this.bizAreaIds = bizAreaIdStr.split(",") || [];
            }
            let bizFormIdStr = this.$route.query.bizFormIdStr || null;
            if(!Utils.isNoB(bizFormIdStr)) {
                this.bizFormIds = bizFormIdStr.split(",") || [];
            }
            let contractNo = this.$route.query.contractNo || null;
            //
            this.getContractGoodsList(contractId, contractNo);
            this.getContractById(contractId);
            if(!Utils.isNoB(contractId)) {
                this.getContractTrackPhase(contractId);
            }
            //
            this.recvFrameList = getEnumList('recvFrame');
            this.invoiceSubjectTypeList = getEnumList('invoiceSubjectType');
        },
        methods: {
            validateBaseQuantity: function (row) {
                let arriveDays = row.arriveDays;
                if(!Utils.isNoB(arriveDays) && !Utils.isNaturalStr(arriveDays)) {
                    row.arriveDays = null;
                    MsgBox.warning("请输入大于0的整数！");
                }
            },
            // 获取适用机构ids
            getAppliedShopIds(callback){
                let self = this;
                let contract = self.contractBizRel || {};
                let theLoading = MsgBox.loading();
                contractApi.getContractAppliedShopIds({
                    contractId: contract.id
                }, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        callback(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择机构
            showShopDlg: function () {
                let self = this;
                let params = {
                    checkBox: false,
                    filter: {
                        merchantId: self.goodsOrderAndTradeDto.buyerId
                    }
                };
                //
                let contract = self.contract;
                if(!Utils.isNoB(contract) && contract.id > 0) {
                    if(Utils.isTrue(contract.bizAreaFlag)) {
                        params.filter.bizAreaIds = self.bizAreaIds || [];
                    }
                    params.filter.bizFormIds = self.bizFormIds || [];
                }
                openRetailerShopListForSelectDlg(params, function (result) {
                    self.retailerCom = result;
                    self.retailerComId = result.id;
                    // @date 2019-02-21 10:41 @author libin @desc 增加联系方式信息
                    self.contactName = self.retailerCom.contactName;
                    self.contactTel = self.retailerCom.contactTel;
                    self.getRetailerAddrListByComId(self.retailerComId);
                    self.getbizAreaPrice();
                });
            },
            // 获取合同商品区域价
            getbizAreaPrice: function () {
                if(!Utils.isNoB(this.contractNo)) {
                    let retailerCom = this.retailerCom;
                    if(!Utils.isNoB(retailerCom.bizAreaId)) {
                        let contractGoodsList = this.contractGoodsList || [];
                        for(let i = 0; i < contractGoodsList.length; i++) {
                            let contractGoods = contractGoodsList[i];
                            if(contractGoods.bizAreaFlag) {
                                let contractGoodsAreaPriceList = contractGoods.contractGoodsAreaPrices || [];
                                for(let j = 0; j < contractGoodsAreaPriceList.length; j++) {
                                    let areaPrice = contractGoodsAreaPriceList[j];
                                    if(areaPrice.bizAreaId == retailerCom.bizAreaId) {
                                        contractGoods.price = Utils.isNoB(areaPrice.price) ? 0.00 : parseFloat(areaPrice.price).toFixed(2);
                                        contractGoods.ntxPrice = Utils.isNoB(areaPrice.ntxPrice) ? 0.00 : parseFloat(areaPrice.ntxPrice).toFixed(2);
                                        break;
                                    }
                                }
                            }
                        }
                        this.contractGoodsList = Utils.merge([], contractGoodsList);
                    }
                }
            },
            getRetailerAddrListByComId: function (shopId) {
                let self = this;

                let postData = {};
                postData.comId = shopId;
                postData.merchantId = self.buyerId;
                postData.recvFlag = true;
                postData.defRevcFlag = true;
                //
                retailerApi.getRetailerAddrList(postData, function (result) {
                    if(result.type === "info") {
                        let addrList = result.data;
                        let retailerCom = self.retailerCom;
                        if(addrList != null && addrList.length > 0) {
                            let addr = addrList[0];
                            retailerCom.shopAddrRegionId = addr.regionId;
                            retailerCom.shopAddrRegionName = addr.regionName;
                            retailerCom.shopAddrStreet = addr.street;
                        } else {
                            retailerCom.shopAddrRegionId = retailerCom.regionId;
                            retailerCom.shopAddrRegionName = retailerCom.regionName;
                            retailerCom.shopAddrStreet = retailerCom.street;
                        }
                        self.retailerCom = Utils.merge({}, retailerCom);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            removeRetailerCom: function () {
                this.retailerCom = null;
            },
            showShopAddrDlg: function () {
                let self = this;
                let retailerCom = self.retailerCom;
                Vue.$showDialog({
                    title: '选择机构收货地址',
                    width: 800,
                    height: 500,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-retailer-addr-select :comId="shopId" :checkBox = "false"  ref="swb_retailer_addr_list_select"></swb-retailer-addr-select>' +
                    '</div>',
                    data: {
                        shopId: retailerCom.id
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_retailer_addr_list_select.getDlgResult() || {};
                        if(result.type == 'info') {
                            let shopAddr = result.data;
                            retailerCom.shopAddrAlias = shopAddr.alias;
                            retailerCom.shopAddrRegionId = shopAddr.regionId;
                            retailerCom.shopAddrRegionName = shopAddr.regionName;
                            retailerCom.shopAddrStreet = shopAddr.street;
                            self.retailerCom = Utils.merge({}, retailerCom);
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {}
                })
            },
            // 获取合同阶段
            getContractTrackPhase: function (contractId) {
                let self = this;
                self.trackPhaseId = null;
                let params = {};
                params.contractId = contractId;
                contractApi.getContractTrackPhaseListByContractId(params, function (reault) {
                    if(reault.type == 'info') {
                        self.trackPhaseList = reault.data;
                        let trackPhaseList = self.trackPhaseList;
                        if(!Utils.isNoB(trackPhaseList) && trackPhaseList.length > 0) {
                            for(let i = 0; i < trackPhaseList.length; i++) {
                                let trackPhase = trackPhaseList[i];
                                if(trackPhase.active) {
                                    self.trackPhaseId = trackPhase.id;
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(reault.message);
                    }
                })
            },
            // 用户信息
            getUserInfo: function () {
                //
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if(result.type == 'info') {
                        self.data = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            checkActionPerm: function (action) {
                return checkUserActionPerm(IntegPurchContractList.path, action, null);
            },
            // 合同信息
            getContractById: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                //
                contractApi.getContractInfo(postData, function (result) {
                    if(result.type == "info") {
                        let contract = result.data;
                        self.goodsOrder.contractId = contract.id;
                        self.goodsOrder.title = contract.title;
                        self.goodsOrder.contractNo = contract.no;
                        self.contractNo = contract.no;
                        self.goodsOrder.contractOriginalNo = contract.originalNo;
                        self.goodsOrder.sellerId = contract.sndPartyId;
                        self.goodsOrder.sellerName = contract.sndPartyName;
                        self.goodsOrder.desireArriveDate = new Date(contract.desireArriveDate);
                        self.goodsOrder.desireArriveDays = contract.desireArriveDays;
                        self.goodsOrder.taxRate = Utils.isNoB(contract.taxRate) ? 0.00 : parseFloat(contract.taxRate).toFixed(2);
                        self.contractBizRel = contract;

                        //获取合同中的发票信息
                        self.goodsOrderAndTradeDto.payWay = contract.payWay;
                        self.goodsOrderAndTradeDto.invoiceTitle = contract.invoiceTitle;
                        self.goodsOrderAndTradeDto.invoiceType = contract.invoiceType;
                        self.goodsOrderAndTradeDto.invoiceContentTag = contract.invoiceContentTag;
                        self.goodsOrderAndTradeDto.taxPayerNo = contract.taxPayerNo;
                        self.goodsOrderAndTradeDto.buyerId = contract.fstPartyId;
                        self.goodsOrderAndTradeDto.buyerType = contract.fstPartyType;

                        let contractGoodsList = contract.contractGoodsList;
                        let goodsOrderItemList = self.goodsOrder.itemList || [];
                        for(let i = 0; i < contractGoodsList.length; i++) {
                            let goodsOrderItem = {};
                            goodsOrderItem.title = contractGoodsList[i].title;
                            goodsOrderItem.goodsId = contractGoodsList[i].goodsId;
                            goodsOrderItem.skuId = contractGoodsList[i].skuId;
                            goodsOrderItem.catId = contractGoodsList[i].catId;
                            goodsOrderItem.catName = contractGoodsList[i].catName;
                            goodsOrderItem.brandId = contractGoodsList[i].brandId;
                            goodsOrderItem.brandName = contractGoodsList[i].brandName;
                            goodsOrderItem.model = contractGoodsList[i].model;
                            goodsOrderItem.fixedSpec = contractGoodsList[i].fixedSpec;
                            goodsOrderItem.wrntPeriod = contractGoodsList[i].wrntPeriod;
                            goodsOrderItem.goodsQuantity = contractGoodsList[i].quantity;
                            goodsOrderItem.price = Utils.isNoB(contractGoodsList[i].price) ? 0.00 : parseFloat(contractGoodsList[i].price).toFixed(2);
                            goodsOrderItem.taxRate = Utils.isNoB(contractGoodsList[i].taxRate) ? 0.00 : parseFloat(contractGoodsList[i].taxRate).toFixed(2);
                            goodsOrderItem.ntxPrice = Utils.isNoB(contractGoodsList[i].ntxPrice) ? goodsOrderItem.price : parseFloat(contractGoodsList[i].ntxPrice).toFixed(2);
                            goodsOrderItem.surplusQuantity = 0;
                            goodsOrderItem.vendorUknoFlag = false;
                            goodsOrderItem.setupFlag = false;
                            goodsOrderItem.asmblFlag = false;
                            goodsOrderItem.arriveDays = null;
                            goodsOrderItem.asmblAccFlag = contractGoodsList[i].asmblAccFlag;
                            goodsOrderItemList.push(goodsOrderItem);
                        }
                        self.goodsOrder.itemList = Utils.merge([], goodsOrderItemList);

                    }
                });
            },
            // 合同商品列表
            getContractGoodsList: function (contractId, contractNo) {
                let self = this;
                let filterItems = {};
                filterItems.contractId = contractId;
                contractApi.getContractGoodsListByContractId(filterItems, function (result) {
                    if(result.type == "info") {
                        let contractGoodsList = result.data || [];
                        for(let i = 0; i < contractGoodsList.length; i++) {
                            let contractGoods = contractGoodsList[i];
                            contractGoods.price = Utils.isNoB(contractGoods.price) ? 0.00 : parseFloat(contractGoods.price).toFixed(2);
                            contractGoods.taxRate = Utils.isNoB(contractGoods.taxRate) ? 0.00 : parseFloat(contractGoods.taxRate).toFixed(2);
                            contractGoods.ntxPrice = Utils.isNoB(contractGoods.ntxPrice) ? contractGoods.price : parseFloat(contractGoods.ntxPrice).toFixed(2);
                        }
                        self.contractGoodsList = Utils.merge([], contractGoodsList);
                        self.getContractGoodsurplusQuantityS(contractNo, self.contractGoodsList);
                        // 设置价格
                        self.getbizAreaPrice();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 移除商品
            removeGoods: function (index) {
                let itemList = this.mkuList;
                for(let i = 0; i < itemList.length; i++) {
                    if(i == index) {
                        itemList.splice(i, 1);
                        i--;
                    }
                }
                this.mkuList = Utils.merge([], itemList);
            },
            // 数量变化
            quantityChanges: function (scope) {
                if(!Utils.isNaturalStr(scope.row.quantity) || scope.row.goodsQuantity <= 0) {
                    Toast.show("【" + scope.row.title + "】请输入有效的下单数量！");
                    return false;
                }
                //
                let totalMoney = 0;
                let contract = this.contractBizRel || {};
                if(!Utils.isNoB(this.contractNo) && !Utils.isNoB(contract.kindId) && contract.kindId == 0) {
                    if(scope.row.goodsQuantity > (scope.row.quantity - scope.row.surplusQuantity)) {
                        Toast.show("【" + scope.row.name + "】请输入有效的下单数量！");
                        return;
                    }
                }
                for(let i = 0; i < this.contractGoodsList.length; i++) {
                    let contractGoods = this.contractGoodsList[i];
                    let quantity = contractGoods.goodsQuantity || 0;
                    let price = contractGoods.price || 0;
                    if(quantity != null && price != null) {
                        totalMoney = totalMoney + quantity * price;
                    }
                }
                this.goodsOrderAndTradeDto.totalAmount = totalMoney.toFixed(2);

//                this.goodsOrder.quantity = scope.row.goodsQuantity;
//                this.goodsOrder.price = scope.row.price;
//                if(scope.row.goodsQuantity != null && scope.row.price != null) {
//                    totalMoney = scope.row.goodsQuantity * scope.row.price;
//                }
//
//                slef.skuList.add(scope.row.skuId);
//                scope.row.amount = amount.toFixed(2);

            },
            // 发票类型
            selectInvoiceType: function (buyId, buyType) {
                let self = this;
                let postData = {};
                merchtFinacApi.getMerchantInvoiceTypeList(postData, function (result) {
                    if(result.type == "info") {
                        let invoiceTypeList = result.data;

                        let invoiceTypeSearchList = [];
                        for(let i = 0; i < invoiceTypeList.length; i++) {
                            let dbInvoiceType = {};
                            let invoiceType = invoiceTypeList[i];
                            if(invoiceType.defaulted) {
                                self.goodsOrderAndTradeDto.invoiceType = invoiceType.value;
                            }
                            dbInvoiceType.value = invoiceType.value;
                            dbInvoiceType.text = invoiceType.name;
                            invoiceTypeSearchList.add(dbInvoiceType);
                        }
                        if(invoiceTypeSearchList.length > 0) {
                            self.invoiceTypeList = Utils.merge([], invoiceTypeSearchList);
                            self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
                        }
                    }
                })
            },
            // 付款时机
            selectPayTiming: function () {
                let self = this;
                let postData = {};
                merchtFinacApi.getMerchantPayTimingList(postData, function (result) {
                    if(result.type == "info") {
                        let payTimingList = result.data;
                        let dbPayTiminghList = [];
                        for(let i = 0; i < payTimingList.length; i++) {
                            let dbPayTiming = {};
                            let payTiming = payTimingList[i];
                            if(payTiming.defaulted) {
                                self.goodsOrderAndTradeDto.payTiming = payTiming.value;
                            }
                            dbPayTiming.value = payTiming.value;
                            dbPayTiming.text = payTiming.name;
                            dbPayTiminghList.add(dbPayTiming);
                        }
                        if(dbPayTiminghList.length > 0) {
                            self.payTimingList = Utils.merge([], dbPayTiminghList)
                            self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
                        }
                    }
                })
            },
            // 支付方式
            selectPayWay: function () {
                let self = this;
                let postData = {};
                merchtFinacApi.getMerchantPayWayList(postData, function (result) {
                    if(result.type == "info") {
                        let payWayList = result.data;
                        let dbPayWayList = [];
                        for(let i = 0; i < payWayList.length; i++) {
                            let dbPayWay = {};
                            let payWay = payWayList[i];
                            if(payWay.defaulted) {
                                self.goodsOrderAndTradeDto.payWay = payWay.value;
                            }
                            dbPayWay.value = payWay.value;
                            dbPayWay.text = payWay.name;
                            dbPayWayList.add(dbPayWay);
                        }
                        if(dbPayWayList.length > 0) {
                            self.payWayList = Utils.merge([], dbPayWayList);
                            self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
                        }
                    }
                })
            },
            // 发票内容标签
            selectInvoiceCtntTag: function () {
                let self = this;
                let postData = {};
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    if(result.type == "info") {
                        let invoiceContentTagList = result.data;
                        for(let i = 0; i < invoiceContentTagList.length; i++) {
                            let invoiceContentTag = invoiceContentTagList[i];
                            if(invoiceContentTag.defaulted) {
                                self.goodsOrderAndTradeDto.invoiceContentTag = invoiceContentTag.name;
                            }
                        }
                        self.invoiceContentTagList = Utils.merge([], invoiceContentTagList);
                    }
                    self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
                })
            },

            //选择发票的信息
            changPayWay: function (item, index) {
                let self = this;
                for(let i = 0; i < self.payWayList.length; i++) {
                    if(i == index) {
                        self.goodsOrderAndTradeDto.payWay = item.value;
                    }
                }
                self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
            },
            // 切换付款时机
            changPayTiming: function (item, index) {
                let self = this;
                for(let i = 0; i < self.payTimingList.length; i++) {
                    if(i == index) {
                        self.goodsOrderAndTradeDto.payTiming = item.value;
                    }
                }
                self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
            },
            // 选择收货时段
            changRecvFrame: function (item, index) {
                let self = this;
                for(let i = 0; i < self.recvFrameList.length; i++) {
                    if(i == index) {
                        self.goodsOrderAndTradeDto.recvFrame = item.value;
                    }
                }
                self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
            },
            // 选择发票主体
            changInvoiceSubjectType: function (item, index) {
                let self = this;
                for(let i = 0; i < self.invoiceSubjectTypeList.length; i++) {
                    if(i == index) {
                        self.goodsOrderAndTradeDto.invoiceSubjectType = item.value;
                    }
                }
                self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
            },
            // 发票内容标签
            changInvoiceContentTag: function (item, index) {
                let self = this;
                for(let i = 0; i < self.invoiceContentTagList.length; i++) {
                    if(i == index) {
                        self.goodsOrderAndTradeDto.invoiceContentTag = item.name;
                    }
                }
                self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
            },
            // 移除合同商品
            removeContractGoods: function (skuId) {
                let self = this;
                let contractGoodsList = self.contractGoodsList;
                for(let i = 0; i < contractGoodsList.length; i++) {
                    let contractGoods = contractGoodsList[i];
                    if(skuId == contractGoods.skuId) {
                        contractGoodsList.splice(i, 1);
                    }
                }
                self.contractGoodsList = Utils.merge([], contractGoodsList);
            },
            // 保存商品订单
            saveGoodsOrder: function () {
                let self = this;
                //
                let trackPhaseList = self.trackPhaseList;
                if(!Utils.isNoB(self.contractNo) && trackPhaseList != null && trackPhaseList.length > 0 && Utils.isNoB(self.trackPhaseId)) {
                    Toast.show("请选择合同阶段");
                    return;
                }
                if(!Utils.isNoB(self.contractNo) && trackPhaseList != null && trackPhaseList.length > 0) {
                    self.goodsOrder.trackPhaseId = self.trackPhaseId;
                    for(let i = 0; i < trackPhaseList.length; i++) {
                        let trackPhase = trackPhaseList[i];
                        if(this.trackPhaseId == trackPhase.id) {
                            self.goodsOrder.trackPhaseName = trackPhase.name;
                        }
                    }
                }
                //
                let contract = this.contractBizRel || {};
                let goodsOrderItems = [];
                let contractGoodsList = self.contractGoodsList || [];
                if(contractGoodsList != null && contractGoodsList.length > 0) {
                    let goodsCount = 0;
                    for(let i = 0; i < contractGoodsList.length; i++) {
                        let contractGoods = contractGoodsList[i];
                        let goodsQuantity = contractGoods.goodsQuantity;
                        if(!Utils.isNaturalStr(goodsQuantity)) {
                            Toast.show("商品【" + contractGoods.name + "】需要输入有效的下单数量！");
                            return false;
                        } else if(Utils.isNoB(goodsQuantity) || goodsQuantity <= 0) {
                            Toast.show("商品【" + contractGoods.name + "】需要输入下单数量！");
                            return false;
                        }
                        if(!Utils.isNoB(self.contractNo) && !Utils.isNoB(contract.kindId) && contract.kindId == 0) {
                            let leftQuantity = contractGoods.quantity - contractGoods.surplusQuantity;
                            if(!Utils.isNaturalStr(goodsQuantity, true)) {
                                if(leftQuantity > 0) {
                                    Toast.show("商品【" + contractGoods.name + "】需要输入下单数量！");
                                } else {
                                    Toast.show("请移除【" + contractGoods.name + "】商品(不可下单)！");
                                }
                                return false;
                            } else if(goodsQuantity > leftQuantity) {
                                Toast.show("商品【" + contractGoods.name + "】 下单数量超过了 剩余数量！");
                                return false;
                            }
                        }
                        //
                        if(!Utils.isNoB(self.contractNo) && !Utils.isNoB(contract.kindId) && (contract.kindId == 1 || (contract.kindId == 0 && contractGoods.goodsQuantity > 0))) {
                            let goodsOrderItem = {};
                            goodsOrderItem.goodsId = contractGoods.goodsId;
                            goodsOrderItem.skuId = contractGoods.skuId;
                            goodsOrderItem.title = contractGoods.title;
                            goodsOrderItem.catId = contractGoods.catId;
                            goodsOrderItem.catName = contractGoods.catName;
                            goodsOrderItem.brandId = contractGoods.brandId;
                            goodsOrderItem.brandName = contractGoods.brandName;
                            goodsOrderItem.model = contractGoods.model;
                            goodsOrderItem.fixedSpec = contractGoods.fixedSpec;
                            goodsOrderItem.quantity = contractGoods.goodsQuantity;
                            goodsOrderItem.unit = contractGoods.unit;
                            goodsOrderItem.price = contractGoods.price || 0;
                            goodsOrderItem.taxRate = contractGoods.taxRate || 0;
                            goodsOrderItem.ntxPrice = contractGoods.ntxPrice || goodsOrderItem.price;
                            goodsOrderItem.wrntPeriod = contractGoods.wrntPeriod;
                            goodsOrderItem.vendorUknoFlag = contractGoods.vendorUknoFlag;
                            goodsOrderItem.setupFlag = contractGoods.setupFlag;
                            goodsOrderItem.asmblFlag = contractGoods.asmblFlag;
                            goodsOrderItem.arriveDays = contractGoods.arriveDays;
                            goodsOrderItem.asmblAccFlag = contractGoods.asmblAccFlag;
                            goodsOrderItems.push(goodsOrderItem);
                            goodsCount++;
                        }
                    }
                }
                if(goodsOrderItems == null || goodsOrderItems.length <= 0) {
                    Toast.show("无有效商品，不可下单！");
                    return false;
                }

                let goodsOrder = self.goodsOrder;

                //合同信息
                goodsOrder.contractId = self.contractBizRel.id;
                goodsOrder.contractNo = self.contractNo;
                goodsOrder.contractOriginalNo = self.contractBizRel.contractOriginalNo;
                goodsOrder.desireArriveDate = goodsOrder.desireArriveDate.format("yyyy-MM-dd");
                //
                let retailerCom = self.retailerCom;
                if(self.contractNo != null) {
                    //商户信息
                    goodsOrder.buyerId = self.contractBizRel.fstPartyId;
                    goodsOrder.buyerComId = self.contractBizRel.fstPartyComId;
                } else {
                    //商户信息
                    if(self.buyerId == null) {
                        Toast.show("无零售商信息！");
                        return false;
                    }
                    goodsOrder.buyerId = self.buyerId;
                    goodsOrder.buyerComId = self.retailerComId;
                }
                // 选择配货机构
                // @date 2019-02-21 10:41 @author libin @desc 增加联系方式信息
                goodsOrder.retailerComId = self.retailerComId;
                if(Utils.isNoB(self.contactName)) {
                    Toast.show("请填写零售商联系人！");
                    return false;
                } else {
                    self.goodsOrderAndTradeDto.buyerRecvContactName = self.contactName;
                }

                if(Utils.isNoB(self.contactTel)) {
                    Toast.show("请填写零售商联系电话！");
                    return false;
                } else {
                    if(!Utils.isPhoneNo(self.contactTel)) {
                        Toast.show("请填写正确的零售商联系电话！");
                        return false;
                    }
                    self.goodsOrderAndTradeDto.buyerRecvContactTel = self.contactTel;
                }
                if(retailerCom != null) {
                    self.goodsOrderAndTradeDto.buyerRecvRegionId = retailerCom.shopAddrRegionId;
                    self.goodsOrderAndTradeDto.buyerRecvStreet = retailerCom.shopAddrStreet;
                }
                //
                goodsOrder.itemList = goodsOrderItems;
                let goodsOrderAndTradeDto = self.goodsOrderAndTradeDto;
                goodsOrderAndTradeDto.goodsOrder = goodsOrder;
                let theLoad = MsgBox.loading();
                goodsOrderApi.saveProxyGoodsOrder(goodsOrderAndTradeDto, function (result) {
                    if(result.type == "info") {
                        MsgBox.success("下单成功");
                        theLoad.close();
                        self.getGoodsOrderList();
                    } else {
                        MsgBox.warning(result.message);
                        //
                        theLoad.close();
                    }
                });
            },

            getContractGoodsurplusQuantityS(contractNo, goodsOrderItemList){
                if(goodsOrderItemList != null) {
                    for(let i = 0; i < goodsOrderItemList.length; i++) {
                        let goodsOrderItem = goodsOrderItemList[i];
                        if(goodsOrderItem.skuId != null) {
                            let postData = {};
                            postData.contractNo = contractNo;
                            postData.skuId = goodsOrderItem.skuId;
                            //
                            goodsOrderApi.getGoodsOrderItemQuantityByContractNoAndSkuId(postData, function (result) {
                                if(result.type == "info") {
                                    goodsOrderItem.surplusQuantity = result.data;
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    }
                }
            },

            getGoodsOrderList: function () {
                let self = this;
                let pushDate = {};
                pushDate.path = SwbGoodsOrderList.path;
                if(self.contractNo != null) {
                    pushDate.query = {contractId: self.contractBizRel.id};
                }
                self.$router.push(pushDate);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/ProxyGoodsOrder.vue